import { useNegotiation } from '@context/negotiation.context';
import Button from '@components/atoms/button/button';
import MmaoService from '@services/mmao-service';
import React, { useMemo, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import useProductQuery from '@hooks/product/use-product-query';
import useHeroPdpStyles from '@hooks/hero-pdp/use-hero-pdp-styles';
import styles from '../CTA-product.module.scss';

export type OfferButtonProps = {
  onClick: () => void;
  triggerMMAO?: boolean;
  className?: string;
  shouldDisplayAsLink?: boolean;
};

const OfferButton: React.FC<OfferButtonProps> = (props): React.JSX.Element => {
  const { onClick, triggerMMAO, className, shouldDisplayAsLink = false } = props;

  const { t } = useTranslation();
  const { negotiation } = useNegotiation();
  const { product, isSellerOnVacation } = useProductQuery();
  const { isHeroPdpStyles } = useHeroPdpStyles();

  const canMakeAnOffer = useMemo<boolean>(
    () => !!product && MmaoService.canMakeAnOffer(product, negotiation),
    [product, negotiation],
  );
  const buttonSize = shouldDisplayAsLink ? 'none' : isHeroPdpStyles ? 'medium' : 'large';
  useEffect(() => {
    if (triggerMMAO) {
      onClick();
    }
  }, [triggerMMAO]);

  return (
    <Button
      disabled={!canMakeAnOffer || isSellerOnVacation}
      onClick={onClick}
      variant={shouldDisplayAsLink ? 'none' : 'secondary'}
      size={buttonSize}
      fullWidth={!shouldDisplayAsLink}
      data-cy="pdp_mmao_btn"
      data-vc-dd-action-name="pdp_mmao_button"
      className={clsx(
        styles.CTAButtonsBlock__button,
        styles['CTAButtonsBlock__button--MMAO'],
        isHeroPdpStyles ? 'vc-btn--large--md-up' : '',
        className,
      )}
    >
      {t('PRODUCT.DETAILS.CTA.NEGOCIATE')}
    </Button>
  );
};

export default OfferButton;
